
export interface AnalyzerDefinition {
    name: string;
    code: string;
}